module.exports = __webpack_public_path__ + "assets/house.67fef6cf.svg";